export class ParseUtil {
  /**
   * Converts given value to a boolean.
   * Only case-insensitive 'true' is considered true, not '1' or 'yes'.
   * @param {string|boolean} value
   * @param defaultValue
   * @return {boolean}
   */
  static convertStringToBoolean(value: string | boolean, defaultValue: boolean = false): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'string') {
      const lowerCaseValue = value.toLowerCase().trim();
      if (lowerCaseValue === 'true') {
        return true;
      }

      if (lowerCaseValue === 'false') {
        return false;
      }

      return defaultValue;
    }

    return defaultValue;
  }

  /**
   * Converts given value to a number. If value cannot be converted or is invalid, default value is returned.
   *
   * @param {string | number} value
   * @param {number} [defaultValue=0]
   * @return {number}
   */
  static convertStringToNumber(value: string | number, defaultValue: number = 0): number {
    if (typeof value === 'number') {
      return isNaN(value) ? defaultValue : value;
    }

    if (typeof value === 'string') {
      const trimmedValue = value.trim();

      if (trimmedValue === '') {
        return defaultValue;
      }

      const parsedNumber = Number(trimmedValue);

      return isNaN(parsedNumber) ? defaultValue : parsedNumber;
    }

    return defaultValue;
  }
}
